// extracted by mini-css-extract-plugin
export var logo = "amazon-module--logo--thR4e";
export var section = "amazon-module--section--CW+oI";
export var show = "amazon-module--show--opN6D";
export var text = "amazon-module--text--nkUgP";